<template>
  <v-dialog
    :value="show" 
    width="500px" 
    height="250px" 
    @input="$emit('changeValue', $event)">
    <v-card class="px-4 pt-4 pb-4">
      <v-card-title>
        <h2>
          Escoger email y asunto
        </h2>
      </v-card-title>
      <v-card-text>
        <vue-perfect-scrollbar>
        <v-layout row wrap py-2 px-4 class="scroll">
          <v-flex xs12>
            <v-text-field
              v-model="form.subject"
              v-validate="'required'"
              data-vv-name="subject"
              data-vv-as="Asunto"
              label="Asunto"
              color="black"/>
          </v-flex>
          <v-flex xs12>
            <v-select
              v-model="form.email"
              :items="emails"
              v-validate="'required'"
              label="Email"
              data-vv-name="email"
              data-vv-as="Asunto"
              item-value="id"
              item-text="email"
              color="black"/>
          </v-flex>
        </v-layout>
        </vue-perfect-scrollbar>
      </v-card-text>
      <v-card-actions>
        <v-layout>
          <v-flex class="text-xs-right xs12" pr-4>
            <v-btn flat color="black" @click="$emit('changeValue', false)">
              CANCELAR
            </v-btn>
            <v-btn class="k-orange-linear-text" flat @click="save">
              GUARDAR
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  inject: ['$validator'],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      form: {
        subject: '',
        email: '',
      },
      cancelToken: this.axios.CancelToken.source(),
      emails: [],
    };
  },
  methods: {
    getEmails() {
      this.axios.get('v2/company_emails', {
        cancelToken: this.cancelToken.token,
      }).then(({ data }) => {
        this.emails = data;
      }).catch(() => {});
    },
    save() {
      this.$emit('changeValue', false);
      this.$emit('save', this.form);
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.getEmails();
      } else {
        this.cancelToken.cancel('');
        this.cancelToken = this.axios.CancelToken.source();
      }
    },
  },
};
</script>
<style scoped>
.scroll {
  height: 150px;
}
</style>


// WEBPACK FOOTER //
// src/components/company_email/SetEmailSubject.vue